import SmartNavigator from '../generic/SmartNavigator'
import Customer from '../configuration/customer/Customer'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

const MainCostumer = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Customers'),
      component: <Customer />
    }
  ]

  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} />
    </div>
  )
}

export default MainCostumer
